import { mapPhone } from '@utils/mapPhone';

export const defaultUserModel = {
  id: null,
  lang: null,
  token: null,
  ltv_provider_id: null,
  email_username: null,
  email_password: null,
  first_name: null,
  last_name: null,
  email: null,
  timezone: null,
  is_temp_password: false,
  phone: null,
  password: null,
  roles: [],
  notification_email: null,
  notification_app: null,
  notification_phone: null,
};

export const userCreateMapping = (item) => {
  const mapped = {
    first_name: item.first_name,
    last_name: item.last_name,
    email: item.email?.toLowerCase(),
    timezone: item.timezone,
    lang: item.lang,
    phone: mapPhone(item.phone),
    notes: item.notes,
    ltv_provider_id: item.ltv_provider_id,
    email_username: item.email_username,
    roles: {
      sync: item.roles.map((role) => role.id),
    },
    notification_email: item.notification_email,
    notification_app: item.notification_app,
    company_id: item.company?.id,
    notification_phone: mapPhone(item.notification_phone),
  };

  if (item.password) {
    mapped.password = item.password;
    mapped.is_temp_password = item.is_temp_password;
  }

  if (item.email_password) {
    mapped.email_password = item.email_password;
  }

  return mapped;
};

export const userUpdateMapping = (item) => ({
  id: item.id,
  ...userCreateMapping(item),
});

export const providerFacilityUserUpdateMapping = (item) => {
  const mapped = {
    id: item.id,
    first_name: item.first_name,
    last_name: item.last_name,
    email: item.email,
    timezone: item.timezone,
    lang: item.lang,
    phone: mapPhone(item.phone),
  };

  if (item.password) {
    mapped.password = item.password;
    mapped.is_temp_password = item.is_temp_password;
  }

  return mapped;
};

export const staffUpdateMapping = (item) => ({
  user_id: item.user.id,
});

export const staffCreateMapping = (item) => staffUpdateMapping(item);
